// extracted by mini-css-extract-plugin
module.exports = {"owner":"PageOwnerTitle_owner__KgZ2C","title":"PageOwnerTitle_title__jM7ev","summary":"PageOwnerTitle_summary__fpab5","joinPageLink":"PageOwnerTitle_joinPageLink__zAENO"};